import React from "react";
import Hours from "./Hours";

const Map = (props) => {
  const { location } = props;

  return (
    <div className="map">
      <div className="map-content">
        <div className="locationName">{location.locationName}</div>
        <img
          className="mapImg"
          src={`https://www.mapquestapi.com/staticmap/v5/map?locations=${location.latitude}%2C${location.longitude}&size=350,272@2x&key=Gmjtd|luuan107n9,75=o5-lz8w0`}
          alt={location.address}
        />
        <p>{`${location.address} ${location.roomNumber}`}</p>
        <p>{`${location.city} ${location.state} ${location.zip}`}</p>
        <p>
          <b>Hours of Operation: </b>
          <Hours hours={location.hours} />
        </p>
        <p>
          <b>Phone: </b>
          {location.phone}
        </p>
        <div id="confirmBtn">
          <button
            className="primary"
            id="confirmBtn"
            onClick={() => {
              window.open(
                "https://www.hertz.com/rentacar/reservation/",
                "_blank"
              );
            }}
          >
            Book Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default Map;
